module.exports = __webpack_public_path__ + "static/unggas-50d5160d060f82acd06bb7b2260eb640.png";